"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
export default function FindYourPathToInnerPeace() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  const teachers = [{
    id: 1,
    name: "Teacher A",
    position: "Senior Dharma Teacher",
    bio: "Specializes in mindfulness and Zen meditation, with over 20 years of practice."
  }, {
    id: 2,
    name: "Teacher B",
    position: "Retreat Coordinator",
    bio: "Experienced in guiding retreats and facilitating group practices."
  }, {
    id: 3,
    name: "Teacher C",
    position: "Dharma Speaker",
    bio: "Focuses on integrating teachings into daily life and community service."
  }, {
    id: 4,
    name: "Teacher D",
    position: "Youth and Community Outreach",
    bio: "Dedicated to making Dharma teachings accessible to all ages."
  }];
  return <section ref={sectionRef} className="relative w-full min-h-screen overflow-hidden bg-background">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1444982/img/sunrise_forest_backdrop.png)"
    }} />
    </section>;
}